import { SETUP_STEPS } from '../../config/setupRoutes';

export default function SetupProgress({ step }) {
  return (
    <div>
      <div className="flex items-center gap-2 mb-3" aria-label={`Setup step ${step} of ${SETUP_STEPS.length}`}>
        {SETUP_STEPS.map((s, i) => {
          const num = i + 1;
          const done = num < step;
          const active = num === step;
          return (
            <div key={s.slug} className="flex items-center gap-2 flex-1 min-w-0">
              <div
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-medium transition-colors ${
                  done
                    ? 'bg-theme-primary text-theme-button'
                    : active
                      ? 'bg-theme-primary/15 text-theme-primary ring-2 ring-theme-primary/30'
                      : 'bg-theme-secondary/50 opacity-50'
                }`}
              >
                {done ? '✓' : num}
              </div>
              <span className={`text-xs truncate hidden sm:block ${active ? 'font-medium' : 'opacity-50'}`}>
                {s.label}
              </span>
              {i < SETUP_STEPS.length - 1 && (
                <div className={`h-px flex-1 ${done ? 'bg-theme-primary/40' : 'bg-theme-secondary'}`} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
